var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productFilter)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.productFilter)}}):_vm._e(),_vm._v(" "),(_vm.bottomSpacer)?_c('div',{staticClass:"dita-content-spacer"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }